import React from "react";
import { createSvgIcon } from "@material-ui/core";

export default createSvgIcon(
  <path d="M12.84,22.72a2,2,0,0,1-1.68,0Q3,18.9,3,15.1V5.1c0-1,.5-1,2-2a16,16,0,0,1,7-2,12.94,12.94,0,0,1,7,2c1.5,1,2,1,2,2,0,.29,0,8.5,0,10Q21,18.91,12.84,22.72ZM19,15.1V13.85c0-.3,0-.89,0-1.95V5.47l-1.12-.71A11,11,0,0,0,12,3.1,13.48,13.48,0,0,0,6.11,4.76L5,5.46V15.1c0,1.51,2.23,3.57,7,5.8C16.77,18.67,19,16.61,19,15.1Zm-7-1.19,2.37,1.25a.4.4,0,0,0,.58-.42l-.45-2.64,1.92-1.87a.41.41,0,0,0-.23-.69l-2.65-.38-1.19-2.4a.39.39,0,0,0-.71,0l-1.19,2.4-2.65.38a.4.4,0,0,0-.22.69L9.51,12.1l-.46,2.64a.4.4,0,0,0,.58.42Z" />,
  "GuardianAdmin"
);
